export const getBankFields = (
  isLoading,
  bankstate,
  setBankState,
) => {
  return [
    {
      type: 'text',
      name: 'bank_desc',
      placeholder: 'Enter Bank Description',
      label: 'Description',
      required: true,
      disabled: isLoading,
      value: bankstate.bank_desc,
      setValue: (e) => {
        const value = e.target.value;
        setBankState({ ...bankstate, bank_desc: value });
      },
    },
  ];
};
